import type { GuestData } from './guest'

export type CheckoutPriceItemType = 'products' | 'non-payable-products' | 'coupon' | 'delivery' | 'on-duty' | 'total'

export type CheckoutPriceItemModel = {
  type: CheckoutPriceItemType
  label?: string
  description: string | null
  cost: number | null
}

export type CheckoutStorage = {
  draftId?: string
  owner?: string
  guestData?: GuestData
  activeStep?: CheckoutStepKey
  isPreviousStepCustomer?: boolean
}

export enum CheckoutStepKey {
  Cart = 'cart',
  Customer = 'customer',
  Delivery = 'delivery',
  Payment = 'payment',
  Overview = 'overview',
  ThankYou = 'thank-you',
}
